module.exports = __webpack_public_path__ + "img/434.fb46bf53.jpg";